module.exports = __webpack_public_path__ + "static/media/mmm-love-home.5bfd0bcf.svg";